import type { AiCapabilityPage } from "../schema.js";
import { LIVE, OWNER_ONLY } from "./_shared.js";

/**
 * `GRP-ARCHIVE-DELETE` (@UC0216) — trang **redirect** (US-AIV2-0049): chat KHÔNG hỏi ô, KHÔNG có nút Đồng ý,
 * chỉ một câu giải thích + nút mở đúng màn hình `/groups/:groupId/settings` (ADR-0009 bất biến 5).
 * Cửa mobile trang này chịu trách nhiệm (hành động PHÁ HUỶ ⇒ CLAUDE.md §4 cấm nút Đồng ý trong chat, bắt buộc deep-link).
 */
export const GRP_ARCHIVE_DELETE = {
  id: "GRP-ARCHIVE-DELETE",
  uc: "@UC0216",
  tier: "redirect",
  status: LIVE,
  roles: OWNER_ONLY,
  flags: [],
  slots: [],
  llm: {
    /*
     * 🔴 US-AIV2-0110 S11 (@UC0273) — câu `known-intent-gaps` `"bo nhom"` (của ACCT-LEAVE-GROUP) ⇒ model chọn trang này (conf
     * 0,62, đo 24/09). Ranh giới đặt Ở ĐÂY chứ không ở ACCT-LEAVE-GROUP: trang này chỉ trưởng nhóm thấy, nên chỉ trưởng nhóm có
     * thể bị nhầm, và nhắc id trang này trong mô tả trang mọi vai thấy là rò nó vào prompt của thành viên (`@UC0152`).
     * ⚠️ Trang đang sát ngưỡng intent (9268 = cách 1 ca, `ai-eval-results.json` @ 3cbdd5242) — câu thêm vào đổi prompt của mọi
     * ca có trang này trong top-8. Đọc kết quả thu của trang này TRƯỚC khi kết luận bản vá có lợi.
     */
    description:
      "Lưu trữ một nhóm đã xong việc, hoặc xoá hẳn nhóm — việc cho CẢ nhóm. Câu mà người nói tự mình rời đi (\"bỏ nhóm\" / \"bo nhom\", \"thoát nhóm\") là ACCT-LEAVE-GROUP, không phải ở đây.",
    examples: [
      "xoá nhóm",
      "xoa nhom",
      "lưu trữ nhóm này",
      "luu tru nhom nay",
      "đóng nhóm lại",
      "ẩn nhóm cũ",
      // ——— 0105: thêm cho đủ 40 ———
      "dong nhom lai",
      "an nhom cu",
      "xoá hẳn nhóm này",
      "xoa han nhom nay",
      "lưu trữ nhóm lớp năm ngoái",
      "luu tru nhom lop nam ngoai",
      "nhóm xong việc rồi, cất đi",
      "nhom xong viec roi cat di",
      "cho nhóm này vào lưu trữ",
      "cho nhom nay vao luu tru",
      "xoá nhóm đội bóng công ty",
      "xoa nhom doi bong cong ty",
      "muốn xoá nhóm thì làm sao?",
      "muon xoa nhom thi lam sao",
      "không dùng nhóm này nữa, xoá giúp",
      "khong dung nhom nay nua xoa giup",
      "archive nhóm",
      "đóng nhóm hội đồng hương",
      "dong nhom hoi dong huong",
      "cất nhóm cũ đi cho gọn",
      "cat nhom cu di cho gon",
      "giải tán nhóm",
      "giai tan nhom",
      "xoá nhóm luôn được không",
      "xoa nhom luon duoc khong",
      "lưu trữ nhóm xong việc",
      "luu tru nhom xong viec",
      "ẩn nhóm này khỏi danh sách",
      "an nhom nay khoi danh sach",
      "nhóm này bỏ đi nhé",
      "nhom nay bo di nhe",
      "xoá nhóm và toàn bộ sổ của nó",
      "xoa nhom va toan bo so cua no",
      "kết thúc nhóm này",
      "ket thuc nhom nay",
    ],
  },
  screen: "/groups/:groupId/settings",
  screenShows: "group_archive_delete",
  endpoints: [
    "POST /groups/{groupId}/archive",
    "DELETE /groups/{groupId}",
  ],
  facts: [],
  templates: {
    redirect: "Mình mở cài đặt nhóm nhé. Lưu trữ thì còn xem lại được; xoá thì cả sổ thu chi của nhóm đi theo — nên việc này phải bấm tận tay.",
  },
  journey: { after: ["GRP-OPEN"] },
  help: { title: "Lưu trữ / xoá nhóm", tryNow: "xoá nhóm" },
} satisfies AiCapabilityPage;
